import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useParams , useLocation} from "react-router-dom";
import { Card, Table, Row, Col, Button, Nav, Tab, } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import API from "api.js";
import ChromeCheck from "views/ChromeCheckGlobal.jsx";
import { NavLink } from "react-router-dom";
import { setUser } from "action/index.js";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { useDispatch, useSelector } from "react-redux";
import { store, persistor } from "store/index";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import InfoIcon from "assets/images/images_new/info-circle.png";
import ArrowIcon from "assets/images/images_new/dropdown-icon.svg";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import EmptyData from "components/EmptyData/EmptyData";
import Spinner from "components/Loader/Spinner";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


function MyChart({ data }) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const chartData = useMemo(() => {
    return data.map((v, k) => ({
      x: k + 1,
      y: v,
    }));
  }, [data]);

  const series = useMemo(
    () => [
      {
        label: "Series 1",
        data: chartData,
      },
    ],
    [chartData]
  );

  const axes = useMemo(
    () => [
      { primary: true, type: "linear", position: "bottom" },
      { type: "linear", position: "left" },
    ],
    []
  );

  const updateUser = () => {
    dispatch(setUser(user));
  };

  console.log(chartData);

  return (
    <div style={{ height: "300px" }}>
      <h6 className="big-title">Sectional score graph</h6>
    </div>
  );
}

function Mock(props) {
  const [extra, setExtra] = useState([]);
  const [data, setData] = useState([]);
  const [graph, setGraph] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [all_ok1, setAllOk1] = useState(true);
  const [all_ok, setAllOk] = useState(true);
  const [mock, setMock] = useState(0);
  const [count, setCount] = useState([100, 100, 100, 100, 100]);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const location = useLocation();
  const { id } = useParams();
  const [isSubscribedCheck, setIsSubscribedCheck] = useState(
    store.getState().subscribed ? store.getState().subscribed : "false"
  );
   const user = useSelector((state) => state.user);

  const getQuestionType = useCallback((type) => {
    switch (type) {
      case 1:
        return "Read Aloud";
      case 2:
        return "Repeat Sentence";
      case 3:
        return "Describe Image";
      case 4:
        return "Re-tell Lecture";
      case 5:
        return "Answer Short Questions";
      case 6:
        return "Summarize Written Text";
      case 7:
        return "Write Essay";
      case 8:
        return "Multiple Choice, Single Answer";
      case 9:
        return "Multiple Choice, Multiple Answers";
      case 10:
        return "Reorder Paragraph";
      case 11:
        return "Fill In The Blanks (Drag & Drop)";
      case 12:
        return "Fill In The Blanks (Drop-Down)";
      case 13:
        return "Summarize Spoken Text";
      case 14:
        return "Multiple Choice, Single Answer";
      case 15:
        return "Multiple Choice, Multiple Answers";
      case 16:
        return "Fill In the Blanks (Type In)";
      case 17:
        return "Highlight Correct Summary";
      case 18:
        return "Select Missing Words";
      case 19:
        return "Highlight Incorrect Words";
      case 20:
        return "Write from Dictation";
       case 21:
        return "Respond To A Situation";
      case 22:
        return "Summarize Group Discussion";
      default:
        return "";
    }
  }, []);

  const getMockType = useCallback(() => {
    switch (id) {
      case "1":
        return "Speaking";
      case "2":
        return "Writing";
      case "3":
        return "Reading";
      case "4":
        return "Listening";
      case "5":
        return "Full";
      default:
        return "";
    }
  }, [id]);

  const getScore = useCallback(
    (key) => {
      let score = 0;
      let from = 0;

      data[key]?.forEach((q) => {
        q.score.forEach((w) => {
          score += w.score;
          from += w.from;
        });
      });

      return from > 0 ? Math.round((score * 100) / from) : 0;
    },
    [data]
  );

  useEffect(() => {
    // const isChrome =
    //   /Chrome/.test(navigator.userAgent) &&
    //   /Google Inc/.test(navigator.vendor) &&
    //   !/Chromium/.test(navigator.userAgent);

    // navigator.mediaDevices.getUserMedia(
    //   { audio: true },
    //   () => {
    //     console.log("Permission Granted");
    //     setAllOk1(isChrome);
    //   },
    //   () => {
    //     console.log("Permission Denied");
    //     setAllOk1(false);
    //   }
    // );

    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("mock");
    const mock = parseInt(myParam) === 1 ? 1 : 0;

    API({
      method: "GET",
      url: `progress/${id}?mock=${mock}`,
    })
      .then((res) => {
        setData(res.data.data);
        setGraph(res.data.graph);
        setMock(mock);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, [id, setAllOk1, setData, setGraph ,location.search]);

  const toggle = useCallback(
    (tab) => {
      if (activeTab === tab) return;
      setActiveTab(tab);

      const shouldBeOk = [1, 5].includes(tab) ? true : true;

      setAllOk(shouldBeOk);
    },
    [activeTab, all_ok1]
  );

  const getTargetedPercentage = useCallback((value) => {
  console.log("The value we got is : ", value);
  console.log("This is user Data SCORE : ", user.score);

  if (user.score == null) {
    return 0;
  }
  
  if ([1, 2, 3, 4, 5, 21, 22].includes(value)) {
    return user.score >= 65 ? 85 : (user.score <= 50 ? 70 : 50);
  }

  if ([6, 7].includes(value)) {
    if (value === 6) {
      return user.score >= 65 ? 90 : (user.score <= 50 ? 80 : 50);
    }
    if (value === 7) {
      return user.score >= 65 ? 85 : (user.score <= 50 ? 70 : 50);
    }
  }
  
  if ([10, 11, 12].includes(value)) {
    return user.score >= 65 ? 70 : (user.score <= 50 ? 50 : 50);
  }

  if ([13, 16, 19, 20].includes(value)) {
    if (value === 13) {
      return user.score >= 65 ? 90 : (user.score <= 50 ? 70 : 50);
    }
    if (value === 16) {
      return user.score >= 65 ? 90 : (user.score <= 50 ? 60 : 50);
    }
    if (value === 19) {
      return user.score >= 65 ? 95 : (user.score <= 50 ? 70 : 50);
    }
    if (value === 20) {
      return user.score >= 65 ? 95 : (user.score <= 50 ? 70 : 50);
    }
  }
  
  return 50;
}, [user.score]);


  // const chartExample4 = useMemo(
  //   () => ({
  //     data: {
  //       labels: graph.map((v, k) => `mock ${k + 1}`),
  //       datasets: [
  //         {
  //           label: "Score",
  //           borderColor: "#fcc468",
  //           fill: true,
  //           backgroundColor: "#fcc468",
  //           hoverBorderColor: "#fcc468",
  //           borderWidth: 8,
  //           barPercentage: 0.4,
  //           data: graph,
  //         },
  //       ],
  //     },
  //     options: {
  //       tooltips: {
  //         tooltipFillColor: "rgba(0,0,0,0.5)",
  //         tooltipFontFamily:
  //           "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  //         tooltipFontSize: 14,
  //         tooltipFontStyle: "normal",
  //         tooltipFontColor: "#fff",
  //         tooltipTitleFontFamily:
  //           "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  //         tooltipTitleFontSize: 14,
  //         tooltipTitleFontStyle: "bold",
  //         tooltipTitleFontColor: "#fff",
  //         tooltipYPadding: 6,
  //         tooltipXPadding: 6,
  //         tooltipCaretSize: 8,
  //         tooltipCornerRadius: 6,
  //         tooltipXOffset: 10,
  //       },
  //       legend: {
  //         display: false,
  //       },
  //       scales: {
  //         yAxes: [
  //           {
  //             ticks: {
  //               fontColor: "#9f9f9f",
  //               fontStyle: "bold",
  //               beginAtZero: true,
  //               maxTicksLimit: 5,
  //               padding: 20,
  //             },
  //             gridLines: {
  //               zeroLineColor: "transparent",
  //               display: true,
  //               drawBorder: false,
  //               color: "#9f9f9f",
  //             },
  //           },
  //         ],
  //         xAxes: [
  //           {
  //             gridLines: {
  //               zeroLineColor: "white",
  //               display: false,
  //               drawBorder: false,
  //               color: "transparent",
  //             },
  //             ticks: {
  //               padding: 20,
  //               fontColor: "#9f9f9f",
  //               fontStyle: "bold",
  //             },
  //           },
  //         ],
  //       },
  //     },
  //   }),
  //   [graph]
  // );
  const chartExample4 = useMemo(
  () => ({
    data: {
      labels: graph.map((v, k) => `mock ${k + 1}`),
      datasets: [
        {
          label: "Score",
          borderColor: "#fcc468",
          fill: true,
          backgroundColor: "#fcc468",
          hoverBorderColor: "#fcc468",
          borderWidth: 8,
          barPercentage: 0.4,
          data: graph,
        },
      ],
    },
    options: {
      plugins: {
        tooltip: {
          backgroundColor: "rgba(0,0,0,0.5)",
          titleFont: {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 14,
            style: "bold",
          },
          bodyFont: {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 14,
            style: "normal",
          },
          titleColor: "#fff",
          bodyColor: "#fff",
          padding: 6,
          cornerRadius: 6,
        },
        legend: {
          display: false,
        },
      },
      scales: {
        y: {
          ticks: {
            color: "#9f9f9f",
            font: {
              style: "bold",
            },
            beginAtZero: true,
            maxTicksLimit: 5,
            padding: 20,
          },
          grid: {
            color: "#9f9f9f",
            display: true,
            drawBorder: false,
          },
        },
        x: {
          grid: {
            color: "transparent",
            display: false,
            drawBorder: false,
          },
          ticks: {
            padding: 20,
            color: "#9f9f9f",
            font: {
              style: "bold",
            },
          },
        },
      },
    },
  }),
  [graph]
);

  return (
    <>
      {true && (
        <div className="content p-0 w-100 tabs-content test-result">
           {/* <DashboardHeader title={mock === 1 ? "Mock Tests" : "Practice Tests"} />  */}
           <DashboardHeader
             title={
                ["1", "2"].includes(new URLSearchParams(location.search).get("mock"))
                  ? "Progress Tracker - Mock Tests"
                  : "Progress Tracker - Practice"
              }
           />
          <div className="outer-wrapper">
            <Col xs={12} className="p-0">
              <Card className="border-0 card-wrapper m-4 w-auto">
                {/* <div className="dailytask-title">Test Result</div> */}

                {/* <Card.Header className="p-0 m-0">
                  <Card.Title className="p-0 m-0" as="h4">
                    Progress Tracker
                  </Card.Title>

                  {graph.length === 0 && (
                    <Card.Text className="text-data-warning">
                      <img src={InfoIcon} alt="LA" />
                      {isSubscribedCheck === true
                        ? " The data below is calculated on the basis of last 3 months performace."
                        : " The data below is calculated on the basis of last 1 months performace."}
                    </Card.Text>
                  )}
                </Card.Header> */}

                <Card.Body className="p-0">
                  <div className="progressTrackerOuter">
                    {/* {!all_ok && (
                      <div className="mt-5">
                        <ChromeCheck />
                      </div>
                    )} */}

                    {all_ok && (
                      <div className="table-wrapper">
                        {loading ? (
                          <div className="text-center py-4">
                            <Spinner/>
                          </div>
                        ) : Object.keys(data).length === 0 ? (
                          <EmptyData />
                        ) : (
                          <Table>
                            <thead className="text-primary">
                              <tr>
                                <th className="table-counting">#</th>
                                <th>Question Type</th>
                                <th>Question Attempted</th>
                                <th>Score Accuracy</th>
                                <th>Targeted Accuracy</th>
                              </tr>
                            </thead>

                            <tbody>
                              {Object.keys(data).map((val, index) => {
                                const array = data[val] || [];

                                const result = array.reduce((acc, o) => {
                                  acc[o.question_id] =
                                    (acc[o.question_id] || 0) + 1;
                                  return acc;
                                }, {});

                                const count = Object.keys(result).length;

                                return (
                                  <tr key={val}>
                                    <td>{index + 1}</td>
                                    <td>{getQuestionType(parseInt(val))}</td>
                                    <td>{count}</td>
                                    <td>{getScore(parseInt(val))}%</td>
                                     {/* <td>{getTargetedPercentage(parseInt(val))}%</td> */}
                                    <td>
                                    {(() => {
                                    const targetPercentage = getTargetedPercentage(parseInt(val));
                                    const showTooltip = targetPercentage === 50 || (user.score > 50 && user.score < 65);
    
                                    return showTooltip ? (
                                      <span className="d-inline-flex align-items-center gap-1 position-relative">
                                      {targetPercentage}%
                                        <span className="info-icon-wrapper">
                                        <i className="bi bi-info-circle-fill info-icon"></i>
                                        <span style={{maxWidth: "150px" ,whiteSpace: "normal",wordWrap: "break-word"}} className="custom-tooltip">
                                         Since this type of question is less important, 50% accuracy will be sufficient.
                                        </span>
                                       </span>
                                      </span>
                                          ) : (
                                            <span>{targetPercentage}%</span>
                                          );
                                      })()}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        )}
                      </div>
                    )}
                  </div>

                  {/* {graph.length > 0 && (
                    <Card className="shadow-none">
                      <Card.Header className="text-center pl-0">
                        <div className="dailytask-title text-center">
                          {getMockType()} Mock Score
                        </div>
                      </Card.Header>

                      <Card.Body className="p-0">
                        <Bar
                          data={chartExample4.data}
                          options={chartExample4.options}
                        />
                      </Card.Body>
                    </Card>
                  )} */}
                </Card.Body>
              </Card>
            </Col>
          </div>
        </div>
      )}
    </>
  );
}

export default Mock;
